import React, { PureComponent } from 'react'

import mainVideo from '../../videos/VFINAL.mp4'
// import mainImageLogo from '../../images/logo-slogan-branco.png'

import './style.css'

class Manutencao extends PureComponent {
    constructor(props) {
        super(props)
        this.height = window.innerHeight
    }

    render() {
        return (
            <>
                <div className="main-video-wrapper" style={{ height: this.height }}>
                    <div className="video-wrapper">
                        <video autoPlay muted loop>
                            <source src={mainVideo} type="video/mp4" />
                        </video>
                    </div>
                </div>
                <div className="main-video-text" id="manutencao">
                    <div className="text-wrapper">
                        <h4>O site do {process.env.REACT_APP_NAME} retornará em breve!</h4>
                        <h4>No momento, a plataforma {process.env.REACT_APP_NAME} está fora do ar para uma manutenção programada, agradecemos a paciência enquanto trabalhamos para melhorar sua experiência em nosso site!</h4>
                        <h4>Estimativa de conclusão: 09h - 08/09/2020</h4>
                        <h5>Siga-nos nas redes sociais para ficar por dentro das novidades:</h5>
                        <h5><a href={process.env.REACT_APP_INSTAGRAM}>Instagram</a> - <a href={process.env.REACT_APP_FACEBOOK || "#"}>Facebook</a> - <a href={process.env.REACT_APP_LINKEDIN}>LinkedIn</a> - <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>E-mail</a></h5>
                        {/* <center><img src={mainImageLogo} alt="banco-flow-main-logo" /></center> */}
                    </div>
                </div>
            </>
        )
    }
}


export default Manutencao